import ContactAPI from 'dashboard/api/contacts';

// Polaris (fase 5, revisão): the open contact as the drawer needs it, kept as a record only. The old page loaded it
// with contacts/show and then contacts/fetchContactableInbox; both commit SET_CONTACT_ITEM, which also adds the
// contact to the list's order, so a contact that is not on the list's page would become an extra row. Here the
// same two requests go through contacts/updateContact (the websocket's path: the record, never the order), in one
// commit, so the inboxes the contact can be written to ("Send message") are never overwritten by the contact.

const contactableInboxesOf = id =>
  ContactAPI.getContactableInboxes(id)
    .then(({ data }) => data.payload)
    .catch(() => undefined);

const withInboxes = (record, contactInboxes) =>
  contactInboxes ? { ...record, contact_inboxes: contactInboxes } : record;

// The contact and its contactable inboxes, from the API. `isStillOpen` drops an answer that arrives after the
// drawer moved to another contact.
export const loadOpenContactRecord = async (
  store,
  id,
  isStillOpen = () => true
) => {
  const [{ data }, contactInboxes] = await Promise.all([
    ContactAPI.show(id),
    contactableInboxesOf(id),
  ]);
  if (!isStillOpen()) return;
  await store.dispatch(
    'contacts/updateContact',
    withInboxes(data.payload, contactInboxes)
  );
};

// After "Update contact": the record the update left, with the contactable inboxes again (the update's payload
// has only the inboxes the contact already talked on).
export const refreshContactInboxes = async (store, id) => {
  const contactInboxes = await contactableInboxesOf(id);
  const record = store.getters['contacts/getContact'](id);
  if (!record?.id || !contactInboxes) return;
  await store.dispatch(
    'contacts/updateContact',
    withInboxes(record, contactInboxes)
  );
};
